import Vue from 'vue';

export type ApplicationMode = 'InvoicingMode' | 'PaycheckMode';

class ApplicationModeService {
  private _currentMode: ApplicationMode;
  private _sidebarExpanded: boolean;

  constructor() {
    const expanded = localStorage.getItem('ApplicationModeService.sidebarExpanded');
    this._sidebarExpanded = expanded === null ? true : expanded === 'true';
    this._currentMode = localStorage.getItem('applicationMode') as ApplicationMode || 'InvoicingMode';
  }

  public toggleSidebarExpanded(value: boolean) {
    localStorage.setItem('ApplicationModeService.sidebarExpanded', String(value));
  }

  public setMode(mode: ApplicationMode) {
    this._currentMode = mode;
    localStorage.setItem('applicationMode', mode);
  }

  public get currentMode(): ApplicationMode {
    return this._currentMode;
  }

  public get sidebarExpanded(): boolean {
    return this._sidebarExpanded;
  }
}

export default Vue.observable(new ApplicationModeService());
